export function slackUserIdFromQuery(query: string) {
  const normalized = query.trim();
  const mention = normalized.match(/^<(?:@|at)([UW][A-Z0-9]+)(?:\|[^>]+)?>$/i);
  if (mention?.[1]) return mention[1].toUpperCase();
  const profileUrl = normalized.match(/\/team\/([UW][A-Z0-9]+)(?:[/?#]|$)/i);
  if (profileUrl?.[1]) return profileUrl[1].toUpperCase();
  const rawId = normalized.match(/^(?:@|at)?([UW][A-Z0-9]{5,})$/i);
  return rawId?.[1]?.toUpperCase();
}
